import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { id: "southwest-scroll-wrapper" }
const _hoisted_3 = {
  class: "map-figure map-scroll-wrapper__map",
  id: "southwest-scroll-wrapper-item"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "map-figure__layer" }
const _hoisted_6 = {
  class: "map-figure__svg",
  width: "1920",
  height: "700",
  viewBox: "0 0 1920 700",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_7 = { class: "event" }
const _hoisted_8 = ["id"]
const _hoisted_9 = ["id"]
const _hoisted_10 = ["id"]
const _hoisted_11 = ["id"]
const _hoisted_12 = ["id"]
const _hoisted_13 = ["id"]
const _hoisted_14 = ["id"]
const _hoisted_15 = ["id"]
const _hoisted_16 = ["id"]
const _hoisted_17 = ["id"]
const _hoisted_18 = ["id"]
const _hoisted_19 = ["id"]
const _hoisted_20 = ["id"]
const _hoisted_21 = ["id"]
const _hoisted_22 = ["id"]
const _hoisted_23 = ["id"]
const _hoisted_24 = ["id"]
const _hoisted_25 = ["id"]
const _hoisted_26 = ["id"]
const _hoisted_27 = ["id"]
const _hoisted_28 = ["id"]
const _hoisted_29 = ["id"]
const _hoisted_30 = ["id"]
const _hoisted_31 = ["id"]
const _hoisted_32 = ["id"]
const _hoisted_33 = ["id"]
const _hoisted_34 = ["id"]
const _hoisted_35 = ["id"]
const _hoisted_36 = ["id"]
const _hoisted_37 = ["id"]
const _hoisted_38 = ["id"]
const _hoisted_39 = ["id"]
const _hoisted_40 = ["id"]
const _hoisted_41 = ["id"]
const _hoisted_42 = ["id"]
const _hoisted_43 = ["id"]
const _hoisted_44 = ["src"]

import { cardSettingsStore } from '@/store/modules/CardSettings';
import { landPlotStore } from '@/store/modules/LandPLot';
import { MixinDetailSection } from '@/mixins/MixinDetailSection';
import { getURL } from '@/helpers/routeHelpers';
import { onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SouthwestDetail',
  setup(__props) {

MixinDetailSection();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "map-figure__bg",
          src: `${_unref(getURL)()}/${require('@/assets/img/Map/newsouthwest-map.png')}`
        }, null, 8, _hoisted_4),
        _createElementVNode("figure", _hoisted_5, [
          (_openBlock(), _createElementBlock("svg", _hoisted_6, [
            _createElementVNode("g", _hoisted_7, [
              _createElementVNode("g", null, [
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '256',
                                )}`,
                  d: "M1205.25 181.478L1195.66 187.583C1195.23 187.851 1194.73 187.952 1194.23 187.865L1146 179.353C1144.9 179.159 1144.17 178.102 1144.38 177.006L1155.61 118.555C1155.82 117.435 1156.93 116.722 1158.04 116.987L1212.68 130.065C1213.71 130.31 1214.36 131.305 1214.19 132.342L1206.15 180.122C1206.05 180.681 1205.73 181.174 1205.25 181.478Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_8),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '257',
                                )}`,
                  d: "M1102.2 106.702L1086.83 168.172C1086.65 168.891 1087.12 169.612 1087.85 169.745L1140.26 179.274C1140.95 179.399 1141.61 178.949 1141.75 178.262L1153.75 117.74C1153.89 117.052 1153.45 116.382 1152.76 116.236L1103.71 105.759C1103.04 105.614 1102.37 106.032 1102.2 106.702Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_9),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '258',
                                )}`,
                  d: "M1027.33 158.654L1043.2 94.2039C1043.37 93.5325 1044.04 93.113 1044.71 93.2554L1099.2 104.726C1099.91 104.876 1100.35 105.585 1100.18 106.29L1084.79 168.35C1084.62 168.999 1083.99 169.416 1083.33 169.307L1028.37 160.226C1027.63 160.104 1027.15 159.38 1027.33 158.654Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_10),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '253',
                                )}`,
                  d: "M1045.31 90.2126L1059.69 29.7952C1059.86 29.0878 1060.58 28.6617 1061.28 28.8563L1112.83 43.1753C1113.49 43.3575 1113.89 44.0202 1113.74 44.6851L1101.27 101.762C1101.12 102.448 1100.45 102.886 1099.76 102.745L1046.3 91.7662C1045.59 91.6206 1045.14 90.917 1045.31 90.2126Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_11),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '252',
                                )}`,
                  d: "M979.255 74.2639L992.226 11.3287C992.375 10.6072 993.099 10.1589 993.811 10.3477L1057.3 27.1813C1057.97 27.3589 1058.38 28.0362 1058.22 28.7112L1044.29 88.761C1044.13 89.447 1043.45 89.8764 1042.76 89.7231L980.232 75.7748C979.548 75.6223 979.113 74.9498 979.255 74.2639Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_12),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '259',
                                )}`,
                  d: "M978.218 79.7442L963.294 145.699C963.134 146.409 963.596 147.11 964.312 147.243L1023.82 158.282C1024.49 158.405 1025.13 157.993 1025.3 157.34L1041.67 93.7866C1041.85 93.0835 1041.41 92.3703 1040.7 92.214L979.746 78.7747C979.057 78.6227 978.374 79.056 978.218 79.7442Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_13),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '274',
                                )}`,
                  d: "M749.362 149.164L738.933 199.415C738.698 200.545 739.466 201.638 740.608 201.801L802.996 210.714C804.099 210.871 805.118 210.098 805.262 208.993L813.241 147.981C813.384 146.886 812.614 145.883 811.52 145.738L761.39 139.118C760.824 139.043 760.253 139.213 759.821 139.587L750.013 148.057C749.68 148.344 749.452 148.733 749.362 149.164Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_14),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '275',
                                )}`,
                  d: "M880.852 158.225L873.654 217.727C873.569 218.43 872.93 218.931 872.227 218.847L808.288 211.155C807.579 211.07 807.076 210.422 807.17 209.714L815.328 147.808C815.422 147.092 816.089 146.594 816.802 146.709L879.781 156.805C880.462 156.914 880.935 157.541 880.852 158.225Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_15),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '276',
                                )}`,
                  d: "M952.858 170.71L946.152 227.704C946.069 228.416 945.418 228.922 944.707 228.826L876.744 219.668C876.053 219.574 875.563 218.946 875.641 218.252L882.348 158.848C882.43 158.116 883.111 157.604 883.838 157.728L951.799 169.296C952.472 169.41 952.937 170.032 952.858 170.71Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_16),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '277',
                                )}`,
                  d: "M1018.79 182.878L1012.73 235.965C1012.6 237.081 1011.58 237.873 1010.47 237.719L949.459 229.271C948.374 229.121 947.611 228.125 947.749 227.038L954.737 172.073C954.88 170.943 955.937 170.161 957.059 170.354L1017.14 180.68C1018.18 180.86 1018.91 181.824 1018.79 182.878Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_17),
                _cache[0] || (_cache[0] = _createTextVNode(" 278")),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '278',
                                )}`,
                  d: "M1091.15 194.506L1082.33 245.107C1082.15 246.165 1081.16 246.888 1080.1 246.746L1016.45 238.26C1015.37 238.115 1014.6 237.132 1014.72 236.049L1020.76 183.568C1020.89 182.44 1021.93 181.646 1023.06 181.821L1089.49 192.186C1090.59 192.359 1091.34 193.404 1091.15 194.506Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_18),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '280',
                                )}`,
                  d: "M1080.69 250.527L1073.27 299.692C1073.12 300.715 1072.21 301.452 1071.17 301.389L1009.1 297.627C1007.96 297.558 1007.11 296.545 1007.24 295.406L1013.27 242.013C1013.4 240.905 1014.4 240.114 1015.51 240.253L1078.97 248.244C1080.08 248.384 1080.86 249.416 1080.69 250.527Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_19),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '281',
                                )}`,
                  d: "M940.718 290.923L946.784 233.058C946.902 231.933 947.929 231.13 949.05 231.286L1009.58 239.733C1010.65 239.882 1011.41 240.851 1011.3 241.923L1005.7 295.096C1005.59 296.16 1004.66 296.948 1003.59 296.882L942.584 293.128C941.448 293.058 940.599 292.056 940.718 290.923Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_20),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '282',
                                )}`,
                  d: "M867.715 286.929L874.287 223.549C874.404 222.427 875.424 221.624 876.542 221.773L943.56 230.74C944.638 230.885 945.403 231.864 945.282 232.945L938.712 291.606C938.593 292.667 937.663 293.447 936.598 293.379L869.578 289.132C868.444 289.06 867.598 288.059 867.715 286.929Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_21),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '283',
                                )}`,
                  d: "M801.158 281.503L806.338 216.048C806.427 214.926 807.423 214.098 808.543 214.217L870.516 220.79C871.612 220.906 872.408 221.888 872.294 222.985L865.701 286.562C865.589 287.64 864.638 288.433 863.557 288.349L802.997 283.655C801.895 283.569 801.071 282.605 801.158 281.503Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_22),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '284',
                                )}`,
                  d: "M723.712 269.042L737.602 206.296C737.827 205.281 738.793 204.607 739.823 204.747L802.627 213.247C803.678 213.389 804.436 214.327 804.353 215.384L799.155 282.015C799.069 283.113 798.112 283.935 797.014 283.854L731.846 279.062C731.305 279.022 730.804 278.765 730.457 278.348L724.128 270.754C723.732 270.278 723.578 269.646 723.712 269.042Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_23),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '298',
                                )}`,
                  d: "M707.333 317.746L695.031 372.63C694.756 373.858 695.67 375.032 696.928 375.067L765.005 376.945C766.108 376.975 767.027 376.108 767.06 375.005L768.942 311.934C768.974 310.856 768.146 309.946 767.069 309.878L722.21 307.045C721.751 307.016 721.296 307.146 720.921 307.413L708.122 316.556C707.721 316.842 707.44 317.266 707.333 317.746Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_24),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '299',
                                )}`,
                  d: "M838.981 316.711L838.02 378.191C838.009 378.909 837.41 379.479 836.691 379.453L770.274 377.046C769.569 377.021 769.017 376.431 769.038 375.726L770.96 311.839C770.982 311.109 771.608 310.545 772.336 310.598L837.793 315.411C838.47 315.461 838.992 316.031 838.981 316.711Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_25),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '300',
                                )}`,
                  d: "M913.566 379.999L915.437 322.919C915.472 321.847 914.655 320.938 913.585 320.859L843.114 315.656C841.967 315.571 840.985 316.469 840.967 317.619L840.031 377.537C840.014 378.627 840.873 379.53 841.962 379.567L911.499 381.932C912.604 381.97 913.529 381.104 913.566 379.999Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_26),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '301',
                                )}`,
                  d: "M994.068 382.032L995.933 327.942C995.97 326.861 995.141 325.946 994.061 325.877L919.058 321.13C917.932 321.059 916.97 321.933 916.933 323.061L915.066 380.474C915.03 381.588 915.912 382.517 917.027 382.538L992.031 383.963C993.123 383.983 994.03 383.124 994.068 382.032Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_27),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '302',
                                )}`,
                  d: "M1076.64 385.564L1080.36 334.972C1080.44 333.879 1079.62 332.925 1078.53 332.833L1000.1 326.178C998.956 326.081 997.967 326.958 997.928 328.102L996.068 382.019C996.03 383.116 996.884 384.038 997.98 384.086L1074.56 387.416C1075.64 387.463 1076.56 386.642 1076.64 385.564Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_28),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '303',
                                )}`,
                  d: "M1155.06 342.412L1148.42 338.261C1148.14 338.09 1147.83 337.987 1147.51 337.963L1084 333.151C1082.9 333.068 1081.93 333.896 1081.85 334.999L1078 387.5L1075.6 436.903C1075.55 438.044 1076.46 439 1077.6 439H1118.47C1118.82 439 1119.16 438.909 1119.46 438.736L1128.83 433.381C1129.26 433.136 1129.59 432.74 1129.74 432.27L1155.9 352.805C1155.97 352.603 1156 352.392 1156 352.179V344.108C1156 343.419 1155.64 342.778 1155.06 342.412Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_29),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '305',
                                )}`,
                  d: "M994.377 387.456L991.136 438.848C991.062 440.01 991.992 440.988 993.156 440.974L1072.1 440.023C1073.16 440.01 1074.03 439.165 1074.07 438.101L1075.92 390.991C1075.97 389.89 1075.11 388.962 1074.01 388.915L996.458 385.584C995.371 385.537 994.445 386.37 994.377 387.456Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_30),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '306',
                                )}`,
                  d: "M912.59 441.847L914.918 385.967C914.964 384.875 915.876 384.022 916.968 384.05L990.906 385.946C992.046 385.976 992.931 386.951 992.849 388.089L989.129 439.704C989.056 440.725 988.223 441.525 987.2 441.559L914.653 443.93C913.491 443.968 912.541 443.009 912.59 441.847Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_31),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '307',
                                )}`,
                  d: "M837.566 442.408L839.436 383.504C839.472 382.398 840.398 381.531 841.503 381.568L911.002 383.932C912.106 383.97 912.97 384.894 912.933 385.998L911.064 441.593C911.028 442.661 910.16 443.511 909.092 443.526L839.593 444.472C838.453 444.487 837.53 443.548 837.566 442.408Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_32),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '308',
                                )}`,
                  d: "M766.063 444.881L767.941 381.497C767.974 380.394 768.894 379.526 769.997 379.557L835.995 381.443C837.101 381.474 837.972 382.399 837.937 383.505L836.059 443.118C836.026 444.175 835.175 445.024 834.117 445.054L768.119 446.939C766.969 446.972 766.029 446.031 766.063 444.881Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_33),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '309',
                                )}`,
                  d: "M679.619 433.036L693.6 378.557C693.834 377.648 694.668 377.023 695.607 377.056L764.011 379.431C765.111 379.469 765.974 380.389 765.941 381.489L764.056 445.099C764.025 446.164 763.164 447.017 762.098 447.039L691.601 448.488C691.209 448.496 690.823 448.388 690.492 448.179L682.204 442.945C681.753 442.66 681.435 442.208 681.319 441.687L679.604 433.967C679.536 433.66 679.541 433.341 679.619 433.036Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_34),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '327',
                                )}`,
                  d: "M663.854 489.686L648.529 561.522C648.259 562.786 649.241 563.97 650.533 563.938L728.049 562.048C729.134 562.021 730 561.134 730 560.048V482C730 480.895 729.105 480 728 480H675.714C675.252 480 674.805 480.16 674.447 480.452L664.543 488.556C664.192 488.843 663.948 489.242 663.854 489.686Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_35),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '331',
                                )}`,
                  d: "M962.024 475.3L963.477 554.724C963.49 555.43 962.93 556.013 962.224 556.03L901.297 557.469C900.583 557.486 899.993 556.917 899.984 556.203L899.015 477.258C899.007 476.559 899.559 475.982 900.257 475.96L960.701 474.041C961.415 474.019 962.011 474.585 962.024 475.3Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_36),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '332',
                                )}`,
                  d: "M1026.53 473.782L1028.47 553.217C1028.49 553.925 1027.93 554.514 1027.22 554.53L966.297 555.969C965.583 555.986 964.993 555.417 964.984 554.703L964.015 475.268C964.007 474.565 964.565 473.986 965.267 473.97L1025.22 472.531C1025.93 472.514 1026.51 473.074 1026.53 473.782Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_37),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '333',
                                )}`,
                  d: "M1093.6 554.5H1031.25C1030.56 554.5 1029.99 553.945 1029.97 553.249L1028.03 473.79C1028.01 473.079 1028.58 472.489 1029.29 472.476L1109.59 471.008C1109.86 471.003 1110.12 471.081 1110.34 471.233L1117.63 476.247C1117.87 476.411 1118.05 476.65 1118.13 476.927L1119.87 482.593C1119.96 482.857 1119.95 483.141 1119.86 483.401L1094.8 553.648C1094.62 554.159 1094.14 554.5 1093.6 554.5Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_38),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '341',
                                )}`,
                  d: "M1013 639.691V557.783C1013 557.074 1013.57 556.5 1014.28 556.5H1091.66C1092.55 556.5 1093.17 557.391 1092.86 558.229L1062.8 639.182C1062.62 639.675 1062.15 640.007 1061.63 640.018L1014.31 640.974C1013.59 640.988 1013 640.41 1013 639.691Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_39),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '342',
                                )}`,
                  d: "M956.985 640.709L956.015 559.275C956.007 558.569 956.569 557.99 957.275 557.977L1009.69 557.024C1010.41 557.011 1011 557.589 1011 558.306V639.741C1011 640.44 1010.44 641.01 1009.74 641.023L958.291 641.976C957.579 641.989 956.993 641.421 956.985 640.709Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_40),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '343',
                                )}`,
                  d: "M900 641.194V560.748C900 560.053 900.553 559.485 901.247 559.465L952.697 558.036C953.413 558.016 954.007 558.587 954.016 559.303L954.985 640.225C954.993 640.931 954.431 641.51 953.725 641.523L901.306 642.476C900.589 642.489 900 641.911 900 641.194Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_41),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '255',
                                )}`,
                  d: "M1213.52 70.3691L1171.29 58.8513C1170.59 58.6596 1169.86 59.0912 1169.7 59.8013L1157.29 113.741C1157.13 114.435 1157.57 115.126 1158.26 115.28L1214.21 127.713C1214.91 127.87 1215.61 127.41 1215.75 126.698L1223.41 85.9967C1223.47 85.6775 1223.4 85.3474 1223.23 85.073L1214.27 70.9203C1214.09 70.6499 1213.83 70.4533 1213.52 70.3691Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_42),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get(
                                    '254',
                                )}`,
                  d: "M1103.27 102.735L1115.22 45.8244C1115.37 45.1047 1116.1 44.6592 1116.81 44.8487L1166.8 58.1801C1167.47 58.3584 1167.88 59.0353 1167.72 59.7096L1155.28 113.286C1155.12 113.962 1154.46 114.391 1153.78 114.253L1104.27 104.256C1103.57 104.115 1103.12 103.432 1103.27 102.735Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_43)
              ])
            ])
          ]))
        ]),
        _createElementVNode("img", {
          class: "map-figure__layer map-figure__layer--disabled",
          src: `${_unref(getURL)()}/${require('@/assets/img/Map/newsouthwest-map-numbers.png')}`
        }, null, 8, _hoisted_44)
      ])
    ])
  ]))
}
}

})